<template>

  </template>
  
  <script>
  import https from "../http.js";
  export default {
    data() {
      return {
        houseData: [],
        quyuData: [],
        today_views:"",
        pcshow:false
      };
    },
    beforeCreate() {
        https
        .fetchGet("/index/mini-index")
        .then(data => {
            console.log(data)
            window.location.href = data.data.url_link;
          //console.log();
        })
        .catch(err => {
          console.log(err);
        });
    },
    created: function() {
    //   this.keepAlive = false;
  
    //   https
    //     .fetchGet("/index/mini-index")
    //     .then(data => {
    //         console.log(data)
    //         window.location.href = data.data.url_link;
    //       //console.log();
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     });
    },
  
    methods: {
      tohouseDetail() {
        if(this.pcshow==true){
          this.pcshow=false;
        }else{
          this.pcshow=true;
        }
     
        //this.$router.push({ path: "/test" });
        //alert(id)
        
      },
  
      toquyusearch(areaid) {
        this.$router.push({ path: "/HouseList", query: { areaid: areaid } });
      },
  
      tohouselist(){
        this.$router.push({ path: "/HouseList"});
      }
    }
  };
  </script> 

 